import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";
import AgGridTable from "../../utilities/AgGridTable";
import ListPageHeader from "../../utilities/ListPageHeader";
import { useNavigate } from "react-router-dom";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { Switch } from "@mui/material";

const VoucherType = () => {
    const url = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.voucherTypes}`;

    const [selectedRows, setSelectedRows] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [error, setError] = useState("")
    const gridRef = useRef();
    const navigate = useNavigate();
    const [snackState, setSnackState] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const [deleteDisable, setDeleteDisable] = useState(true);

    
    const [columnDefs, setColumnDefs] = useState([
        { field: 'shortKey',enableRowGroup: true },
        { field: 'description', enableRowGroup: true },
    ]);


    const findvoucherTypes = async () => {
        try {
            const list = await OAuthService.getList(url + `?sort=code,asc&size=1000`);
            const voucherTypes = list.data?._embedded?.voucherTypes
            setRowData(voucherTypes);
        } catch (error) {
            setError(error.message);
        }
    }

    const onGridReady = useCallback((params) => {
        findvoucherTypes();
        var columnToolPanel = gridRef.current.api.getToolPanelInstance('columns');
        columnToolPanel.expandColumnGroups();
    }, []);

    
    const onBtExport = useCallback(() => {
        const params = {
            fileName: 'VoucherType.xlsx',
            sheetName: 'Voucher Type'
        }
        gridRef.current.api.exportDataAsExcel(params);
    }, []);

    const handlePurge = (e) => {
        selectedRows.map(async (row) => {
            // var filename = row?._links?.user?.href.split('/').pop()
            try {
                await OAuthService.deleteData(url, row?._links?.self?.href.split('/').pop());
                setSuccessMsg("Data deleted Successfully")
                setSnackState(true);
                findvoucherTypes();
            } catch (error) {
                setError(error.message);
            }
        })
    };

    const onSelectionChanged = (params) => {
        setSelectedRows(params.api.getSelectedRows());
    }

    const onRowDoubleClicked = (params) => {
        navigate('/editVoucherType/' + selectedRows[0]?._links?.self?.href.split('/').pop());
    }

    useEffect(() => {
        if (selectedRows.length > 0) {
            setDeleteDisable(false)
        } else {
            setDeleteDisable(true)
        }
    }, [selectedRows])

    return (
        <>
            <ListPageHeader
                componentName="Voucher Type"
                onBtExport={onBtExport}
                handlePurge={handlePurge}
                addPageLink="/addVoucherType"
                pageName="Voucher Type List"
                error={error}
                successMsg={successMsg}
                snackState={snackState}
                deleteDisable={deleteDisable}
                gridRef={gridRef}
            />
            <div className="h-full">
                <AgGridTable
                    rowData={rowData}
                    columnDefs={columnDefs}
                    onGridReady={onGridReady}
                    onSelectionChanged={onSelectionChanged}
                    onRowDoubleClicked={onRowDoubleClicked}
                    gridRef={gridRef}
                    paginationPageSize={10}
                    cacheBlockSize={10}
                    saveGridStateName={'VoucherTypeList'}
                />
            </div>
        </>
    )
}

export default VoucherType